module.exports = __webpack_public_path__ + "img/keyboard.32ebd196.png";